import { render, staticRenderFns } from "./CardOffer.vue?vue&type=template&id=2afa23d0&scoped=true"
import script from "./CardOffer.vue?vue&type=script&lang=js"
export * from "./CardOffer.vue?vue&type=script&lang=js"
import style0 from "./CardOffer.vue?vue&type=style&index=0&id=2afa23d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa23d0",
  null
  
)

export default component.exports